import { ThemeWrapper } from "@verity/components";
import { CorePaper } from "@verity/components/core";
import LockdownSetupInstructions from "../../../setup/components/LockdownSetupInstructions";
import styles from "./index.module.css";
import VisualizerBanner from "../visualizer-banner";

export default function LockdownSetupPage() {
	return (
		<ThemeWrapper scopedCssBaselineProps={{ className: styles.page }}>
			<div className={styles.visualizerBanner}>
				<VisualizerBanner />
			</div>
			<CorePaper shadowStyle="wide" className={styles.contentWrapper}>
				<LockdownSetupInstructions />
			</CorePaper>
		</ThemeWrapper>
	);
}
